import styled from "styled-components";


export const TermsCardsSection = styled.section`

& h2{
	font-weight: 500;
}

.terms-cards__container{
	margin-top: 3.75rem;
	gap: 1.875rem;
}

.wrap__container{
	flex-wrap: nowrap;
}

@media(max-width:999px){

	.terms-cards__container{
	gap: 2.875rem;
}
.wrap__container{
	flex-wrap: wrap;
}
}

@media(max-width:631px){
		.terms-cards__container{
	gap: 0.875rem;
}
}
`
export const DemandedSection = styled.section`

.demanded-cards__container{
	margin-top: 3.75rem;
	flex-wrap: wrap;
	gap: 2.5rem;
	& div {
		width: 30%;
		height: 17.5rem;

		& iframe {
			width: 100%;
			height: 100%;
		}
	}
}

@media(max-width:999px){
.demanded-cards__container{
	
	& div {
		width: 47%;
		height: 17.5rem;
	}
}
}
@media(max-width:768px){
.demanded-cards__container{
	
	& div {
		width: 100%;
		height: 10.5rem;
	}
}
}


`

export const PopularAssetsSection = styled.section`

& p {
	margin-top: 1.25rem;
}

.widget{
	margin-top: 3.75rem;
	width: 100%;
	height: 37.5rem;
	& iframe{
		width: 100%;
		height: 100%;
	}
}
`